module.exports = __webpack_public_path__ + "officialStatic/img/money.4176567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/money.png
// module id = z42X
// module chunks = 0